'use client';

import { useEffect, useState } from 'react';
import { isProduction } from '@alltrails/core/utils/Environment';

const HIGHLIGHT_CLASS = 'denali-highlight-mode';

const useDenaliToggleMode = () => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || isProduction()) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.altKey && event.shiftKey && event.code === 'KeyD') {
        event.preventDefault();
        setIsActive(prev => !prev);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined' || isProduction()) {
      return;
    }

    document.documentElement.classList.toggle(HIGHLIGHT_CLASS, isActive);

    return () => {
      document.documentElement.classList.remove(HIGHLIGHT_CLASS);
    };
  }, [isActive]);

  return isActive;
};

export default useDenaliToggleMode;
